export const enAgentGuiProjectLaunch = {
  projectLocked: "Project cannot be changed after the session starts",
  projectMissingDescription:
    "This conversation's working directory no longer exists",
  sessionLaunchModeLabel: "Session launch mode",
  sessionLaunchModeLocal: "Local",
  sessionLaunchModeWorktree: "Worktree"
};
